import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui';

/** Default UI for a caught render error. Lives apart from the boundary itself
 *  because the boundary must stay a class, and mixing the two in one file breaks
 *  fast refresh. */
export function ErrorFallback({ onReset }: { onReset: () => void }) {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className="mx-auto flex min-h-[50vh] max-w-sm flex-col items-center justify-center gap-3 px-6 text-center"
    >
      <h1 className="text-title font-semibold">{t('errors.title')}</h1>
      <p className="text-body-sm text-[var(--text-muted)]">{t('errors.description')}</p>
      <Button onClick={onReset}>{t('common.retry')}</Button>
    </div>
  );
}
